import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import api from "../../api.js";

const MyReports = () => {
  const [reports, setReports] = useState([]);
  const token = Cookies.get("access_token");

  useEffect(() => {
    api.get("/report/me/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      setReports(res.data);
    }).catch((err) => {
      console.error("Error fetching reports", err);
    });
  }, []);

  return (
    <div className="container">
      {reports.length === 0 ? (
        <p>هیچ گزارشی ثبت نشده است.</p>
      ) : (
        <div className="row">
          {reports.map((report) => (
            <div className="col-12 col-md-6 col-lg-4 mb-4" key={report.id}>
              <Link to={`/report/${report.id}`} className="text-decoration-none text-dark">
                <div className="card h-100 shadow-sm hover-shadow">
                  <div className="card-body">
                    <h5 className="card-title">{report.title}</h5>
                    <p className="card-text text-truncate">{report.content}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyReports;
